// eslint-disable-next-line import/no-nodejs-modules
import { Buffer } from 'buffer';
// eslint-disable-next-line import/no-extraneous-dependencies
import { parse, ParsedQs, stringify } from 'qs';

type ObjectMap = {
  [key: string]: string;
};

export function encodeParam(param: string): string {
  const useUrlEncoding = localStorage.getItem('useUrlEncoding') === 'true';
  if (useUrlEncoding) {
    return param || param != null
      ? Buffer.from(encodeURIComponent(param.toString()), 'utf8').toString(
          'base64'
        )
      : '';
  } else return param;
}

export function decodeParam(param: string): string {
  const useUrlEncoding = localStorage.getItem('useUrlEncoding') === 'true';
  if (!useUrlEncoding) return param;

  if (!param) return '';

  try {
    const base64Decoded = Buffer.from(param, 'base64').toString('utf8');
    return decodeURIComponent(base64Decoded);
  } catch (error) {
    console.warn('Failed to decode parameter:', error);
    return param;
  }
}

function encodeParams(params: ParsedQs): ObjectMap {
  const encodedParams: ObjectMap = {};
  Object.keys(params).forEach((prop: string) => {
    encodedParams[prop] = encodeParam(params[prop] as string);
  });
  return encodedParams;
}

function decodeParams(params: ParsedQs): ObjectMap {
  const decodedParams: ObjectMap = {};
  if (params) {
    Object.keys(params).forEach((prop: string) => {
      decodedParams[prop] = decodeParam(params[prop] as string);
    });
  }
  return decodedParams;
}

export function encodeDecodeUrl(url: string, decode = false): string {
  if (url.indexOf('?') === -1) {
    url = `?${url}`;
  }
  const [route, params] = url.split('?');
  const parsedParams = parse(params);
  const resultParams = decode
    ? decodeParams(parsedParams)
    : encodeParams(parsedParams);
  const resultUrl = `${route}?${stringify(resultParams)}`;
  return resultUrl;
}
